import React from 'react';

import IISC2025 from 'views/IISC2025';

const SchoolProgrampage = () => {
  return <IISC2025 />;
};

export default SchoolProgrampage;